export const CanvasIconTypes = {
	Accent: "accent",
	Applet: "applet",
	System: "system",
	Graphic: "graphic",
}